export default "//cloud.imgsmail.ru/cloud.mail.ru/131475/img/build/overquotaMobile.png";